/* eslint-disable no-useless-escape */
const detectPage = [
  {
    regex: /my-apps[\/]new/i,
    crumb: {
      label: 'Add New APP',
      url: '',
    },
  },
  {
    regex: /my-apps[\/]edit/i,
    crumb: {
      label: 'Edit APP',
      url: '',
    },
  },
  {
    regex: /my-apis[\/]new/i,
    crumb: {
      label: 'Add New API',
      url: '',
    },
  },
  {
    regex: /my-apis[\/]edit/i,
    crumb: {
      label: 'Edit API',
      url: '',
    },
  },
  {
    regex: /my-services[\/]new/i,
    crumb: {
      label: 'Add Service',
      url: '',
    },
  },
  {
    regex: /my-services[\/]edit/i,
    crumb: {
      label: 'Edit Service',
      url: '',
    },
  },
  {
    regex: /service-categories[\/]new/i,
    crumb: {
      label: 'Add Service Category',
      url: '',
    },
  },
  {
    regex: /service-categories[\/]edit/i,
    crumb: {
      label: 'Edit Service Category',
      url: '',
    },
  },
  {
    regex: /api-categories[\/]new/i,
    crumb: {
      label: 'Add API Category',
      url: '',
    },
  },
  {
    regex: /api-categories[\/]edit/i,
    crumb: {
      label: 'Edit API Category',
      url: '',
    },
  },
  {
    regex: /app-categories[\/]new/i,
    crumb: {
      label: 'Add APP Category',
      url: '',
    },
  },
  {
    regex: /app-categories[\/]edit/i,
    crumb: {
      label: 'Edit APP Category',
      url: '',
    },
  },
];

export { detectPage };
